import React from "react";
import { Box, Button, Theme, Typography } from "@mui/material";
import { CheckMarkIcon } from "./LineIcons";

interface Props {
  text?: string;
  icon?: JSX.Element;
  selected?: boolean;
  onClick?: (selected: boolean) => void;
}

export const IconButton = ({
  text,
  icon,
  selected,
  onClick,
}: Props): JSX.Element => {
  return (
    <Button
      sx={{
        boxShadow: "2px 2px 6px rgba(116, 135, 164, 0.4)",
        borderRadius: "10px",
        color: (theme: Theme) =>
          selected ? theme.palette.secondary.light : theme.palette.common.white,
        border: "solid 1px",
        backgroundColor: (theme: Theme) =>
          selected ? theme.palette.success.light : "none",
        "&:hover": {
          color: (theme: Theme) => theme.palette.secondary.light,
          border: "solid 1px",
          backgroundColor: (theme: Theme) => theme.palette.success.light,
        },
      }}
      disableRipple
      fullWidth
      onClick={() => onClick && onClick(!selected)}
    >
      <Box
        sx={{
          pt: 2,
          px: 3,
          pb: 2,
          minWidth: "180px",
          minHeight: "156px",
          display: "flex",
          gap: 1,
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {selected ? (
          <CheckMarkIcon sx={{ width: 60, height: 60 }} viewBox="0 0 60 60" />
        ) : (
          icon
        )}
        <Typography variant="body2" sx={{ lineHeight: "20px" }}>
          {text}
        </Typography>
      </Box>
    </Button>
  );
};
